import Data from 'data';
import jsep from 'jsep';

const binaryPrecedence = {
  '==': 6, '!=': 6,
  '<': 7,  '>': 7,  '<=': 7,  '>=': 7,
  '+': 9, '-': 9,
  '*': 10, '/': 10,
};
const binaryOps = {
  '==': (a, b) => a === b ? 1 : 0,
  '!=': (a, b) => a !== b ? 1 : 0,
  '<': (a, b) => a < b ? 1 : 0,
  '>': (a, b) => a > b ? 1 : 0,
  '<=': (a, b) => a <= b ? 1 : 0,
  '>=': (a, b) => a >= b ? 1 : 0,
  '+': (a, b) => (a + b) | 0,
  '-': (a, b) => (a - b) | 0,
  '*': (a, b) => (a * b) | 0,
  '/': (a, b) => b ? ((a / b) | 0) : 0,
};
const unaryOps = {
  '-': x => (-x) | 0,
  '+': x => x,
};

jsep.removeAllUnaryOps();
jsep.removeAllBinaryOps();
jsep.removeAllLiterals();
for (const op in binaryOps) {
  jsep.addBinaryOp(op, binaryPrecedence[op]);
}
for (const op in unaryOps) {
  jsep.addUnaryOp(op);
}

function linear(lvl, a, b) {
  return (a + b * (lvl - 1)) | 0;
}
function diminishing(lvl, a, b) {
  return (((110 * lvl) / (lvl + 6) | 0) * (b - a) / 100 | 0) + a;
}

function levelScaling5(lvl, base, s1, s2, s3, s4, s5) {
  if (lvl > 28) return (base + s1 * 7 + s2 * 8 + s3 * 6 + s4 * 6 + s5 * (lvl - 28)) | 0;
  if (lvl > 22) return (base + s1 * 7 + s2 * 8 + s3 * 6 + s4 * (lvl - 22)) | 0;
  if (lvl > 16) return (base + s1 * 7 + s2 * 8 + s3 * (lvl - 16)) | 0;
  if (lvl > 8) return (base + s1 * 7 + s2 * (lvl - 8)) | 0;
  return (base + s1 * (lvl - 1)) | 0;
}

function levelScaling3(lvl, base, s1, s2, s3) {
  if (lvl > 16) return (base + s1 * 7 + s2 * 8 + s3 * (lvl - 16)) | 0;
  if (lvl > 8) return (base + s1 * 7 + s2 * (lvl - 8)) | 0;
  return (base + s1 * (lvl - 1)) | 0;
}

export function skillPassiveStatsLazy(skill, stats, level) {
  const result = {};
  if (skill.passivestat1) result[skill.passivestat1] = () => skillCalc(skill, skill.passivecalc1, stats, level);
  if (skill.passivestat2) result[skill.passivestat2] = () => skillCalc(skill, skill.passivecalc2, stats, level);
  if (skill.passivestat3) result[skill.passivestat3] = () => skillCalc(skill, skill.passivecalc3, stats, level);
  if (skill.passivestat4) result[skill.passivestat4] = () => skillCalc(skill, skill.passivecalc4, stats, level);
  if (skill.passivestat5) result[skill.passivestat5] = () => skillCalc(skill, skill.passivecalc5, stats, level);
  return result;
}

export function skillAuraStatsLazy(skill, stats, level) {
  const result = {};
  if (skill.aurastat1) result[skill.aurastat1] = () => skillCalc(skill, skill.aurastatcalc1, stats, level);
  if (skill.aurastat2) result[skill.aurastat2] = () => skillCalc(skill, skill.aurastatcalc2, stats, level);
  if (skill.aurastat3) result[skill.aurastat3] = () => skillCalc(skill, skill.aurastatcalc3, stats, level);
  if (skill.aurastat4) result[skill.aurastat4] = () => skillCalc(skill, skill.aurastatcalc4, stats, level);
  if (skill.aurastat5) result[skill.aurastat5] = () => skillCalc(skill, skill.aurastatcalc5, stats, level);
  if (skill.aurastat6) result[skill.aurastat6] = () => skillCalc(skill, skill.aurastatcalc6, stats, level);
  return result;
}

export function skillPassiveStats(skill, stats, level) {
  const result = {};
  if (skill.passivestat1) result[skill.passivestat1] = skillCalc(skill, skill.passivecalc1, stats, level);
  if (skill.passivestat2) result[skill.passivestat2] = skillCalc(skill, skill.passivecalc2, stats, level);
  if (skill.passivestat3) result[skill.passivestat3] = skillCalc(skill, skill.passivecalc3, stats, level);
  if (skill.passivestat4) result[skill.passivestat4] = skillCalc(skill, skill.passivecalc4, stats, level);
  if (skill.passivestat5) result[skill.passivestat5] = skillCalc(skill, skill.passivecalc5, stats, level);
  return result;
}

export function skillAuraStats(skill, stats, level) {
  const result = {};
  if (skill.aurastat1) result[skill.aurastat1] = skillCalc(skill, skill.aurastatcalc1, stats, level);
  if (skill.aurastat2) result[skill.aurastat2] = skillCalc(skill, skill.aurastatcalc2, stats, level);
  if (skill.aurastat3) result[skill.aurastat3] = skillCalc(skill, skill.aurastatcalc3, stats, level);
  if (skill.aurastat4) result[skill.aurastat4] = skillCalc(skill, skill.aurastatcalc4, stats, level);
  if (skill.aurastat5) result[skill.aurastat5] = skillCalc(skill, skill.aurastatcalc5, stats, level);
  if (skill.aurastat6) result[skill.aurastat6] = skillCalc(skill, skill.aurastatcalc6, stats, level);
  return result;
}

export const AuraFlags = {
  FindPlayers:      0x00000001,
  FindMonsters:     0x00000002,
  OnlyUndead:       0x00000004,
  FindMissiles:     0x00000008,
  FindObjects:      0x00000010,
  FindItems:        0x00000020,
  OnlyAttackable:   0x00000080,
  NotInsideTown:    0x00000100,
  UseLineOfSight:   0x00000200,
  OnlySelectable:   0x00000400,
  OnlyCorpses:      0x00001000,
  NotInsideTown2:   0x00002000,
  IgnoreBosses:     0x00004000,
  IgnoreAllies:     0x00008000,
  TargetAllies:     0x00010000,
  IgnorePrimeEvils: 0x00040000,
  IgnoreJustHit:    0x00080000,
};

export function missileFormula(missile, ident, stats, level) {
  const pctcalc = (value, pct) => d2_addpercent(value, missileCalc(missile, pct, stats, level));
  const pctcalc2 = (value, pct) => missile.etype === 'ltng' ? value : pctcalc(value, pct);
  switch (ident) {
  case 'par1': return missile.param1 || 0;
  case 'par2': return missile.param2 || 0;
  case 'par3': return missile.param3 || 0;
  case 'par4': return missile.param4 || 0;
  case 'par5': return missile.param5 || 0;
  case 'cpa1': return missile.cltparam1 || 0;
  case 'cpa2': return missile.cltparam2 || 0;
  case 'cpa3': return missile.cltparam3 || 0;
  case 'cpa4': return missile.cltparam4 || 0;
  case 'cpa5': return missile.cltparam5 || 0;
  case 'hpa1': return missile.shitpar1 || 0;
  case 'hpa2': return missile.shitpar2 || 0;
  case 'hpa3': return missile.shitpar3 || 0;
  case 'chp1': return missile.chitpar1 || 0;
  case 'chp2': return missile.chitpar2 || 0;
  case 'chp3': return missile.chitpar3 || 0;
  case 'dpa1': return missile.dparam1 || 0;
  case 'dpa2': return missile.dparam2 || 0;
  case 'lvl': return level;
  case 'edmn': return (pctcalc2(levelScaling5(level, missile.emin || 0, missile.minelev1 || 0, missile.minelev2 || 0,
    missile.minelev3 || 0, missile.minelev4 || 0, missile.minelev5 || 0), missile.edmgsympercalc) << (missile.hitshift || 0)) >> 8;
  case 'edmx': return (pctcalc(levelScaling5(level, missile.emax || 0, missile.maxelev1 || 0, missile.maxelev2 || 0,
    missile.maxelev3 || 0, missile.maxelev4 || 0, missile.maxelev5 || 0), missile.edmgsympercalc) << (missile.hitshift || 0)) >> 8;
  case 'edln': return levelScaling3(level, missile.elen || 0, missile.elevlen1 || 0, missile.elevlen2 || 0, missile.elevlen3 || 0);
  case 'edns': return pctcalc2(levelScaling5(level, missile.emin || 0, missile.minelev1 || 0, missile.minelev2 || 0,
    missile.minelev3 || 0, missile.minelev4 || 0, missile.minelev5 || 0), missile.edmgsympercalc) << (missile.hitshift || 0);
  case 'edxs': return pctcalc(levelScaling5(level, missile.emax || 0, missile.maxelev1 || 0, missile.maxelev2 || 0,
    missile.maxelev3 || 0, missile.maxelev4 || 0, missile.maxelev5 || 0), missile.edmgsympercalc) << (missile.hitshift || 0);
  case 'rang': return linear(level, missile.range || 0, missile.levrange || 0);
  case 'sl12': return linear(level, missile.param1 || 0, missile.param2 || 0);
  case 'sd12': return diminishing(level, missile.param1 || 0, missile.param2 || 0);
  case 'sl34': return linear(level, missile.param3 || 0, missile.param4 || 0);
  case 'sd34': return diminishing(level, missile.param3 || 0, missile.param4 || 0);
  case 'cl12': return linear(level, missile.cltparam1 || 0, missile.cltparam2 || 0);
  case 'cd12': return diminishing(level, missile.cltparam1 || 0, missile.cltparam2 || 0);
  case 'cl34': return linear(level, missile.cltparam3 || 0, missile.cltparam4 || 0);
  case 'cd34': return diminishing(level, missile.cltparam3 || 0, missile.cltparam4 || 0);
  case 'shl1': return linear(level, missile.shitpar1 || 0, missile.shitpar2 || 0);
  case 'shd1': return diminishing(level, missile.shitpar1 || 0, missile.shitpar2 || 0);
  case 'chl1': return linear(level, missile.chitpar1 || 0, missile.chitpar2 || 0);
  case 'chd1': return diminishing(level, missile.chitpar1 || 0, missile.chitpar2 || 0);
  case 'dl12': return linear(level, missile.dparam1 || 0, missile.dparam2 || 0);
  case 'dd12': return diminishing(level, missile.dparam1 || 0, missile.dparam2 || 0);
  case 'size': return missile.size || 0;

  case 'pdmn': return pctcalc(levelScaling5(level, missile.mindamage || 0, missile.minlevdam1 || 0, missile.minlevdam2 || 0,
    missile.minlevdam3 || 0, missile.minlevdam4 || 0, missile.minlevdam5 || 0) << (missile.hitshift || 0), missile.dmgsympercalc) >> 8;
  case 'pdmx': return pctcalc(levelScaling5(level, missile.maxdamage || 0, missile.maxlevdam1 || 0, missile.maxlevdam2 || 0,
    missile.maxlevdam3 || 0, missile.maxlevdam4 || 0, missile.maxlevdam5 || 0) << (missile.hitshift || 0), missile.dmgsympercalc) >> 8;
  case 'pdns': return pctcalc(levelScaling5(level, missile.mindamage || 0, missile.minlevdam1 || 0, missile.minlevdam2 || 0,
    missile.minlevdam3 || 0, missile.minlevdam4 || 0, missile.minlevdam5 || 0) << (missile.hitshift || 0), missile.dmgsympercalc);
  case 'pdxs': return pctcalc(levelScaling5(level, missile.maxdamage || 0, missile.maxlevdam1 || 0, missile.maxlevdam2 || 0,
    missile.maxlevdam3 || 0, missile.maxlevdam4 || 0, missile.maxlevdam5 || 0) << (missile.hitshift || 0), missile.dmgsympercalc);
  default: return 0;
  }
}

export function d2_percent(value, pct) {
  if (value < 1048576) {
    return ((value * pct / 100) | 0);
  } else {
    return ((value / 100) | 0) * pct;
  }
}
export function d2_addpercent(value, pct) {
  if (value < 1048576) {
    return value + ((value * pct / 100) | 0);
  } else {
    return value + ((value / 100) | 0) * pct;
  }
}

export function skillFormula(skill, ident, stats, level) {
  if (!skill || !level) return 0;

  const pctcalc = (value, pct) => d2_addpercent(value, skillCalc(skill, pct, stats, level));
  const pctcalc2 = (value, pct) => {
    if (skill.emin === 1 && !skill.eminlev1 && !skill.eminlev2 && !skill.eminlev3 && !skill.eminlev4 && !skill.eminlev5) {
      return value;
    } else {
      return pctcalc(value, pct);
    }
  };
  const mastery = value => {
    const pct = stats.base?.[`passive_${skill.etype}_mastery`];
    if (!pct) return value;
    return d2_addpercent(value, pct);
  };
  const passiveStat = (...names) => {
    const passive = skillPassiveStatsLazy(skill, stats, level);
    for (const name of names) {
      if (passive[name]) return passive[name]();
    }
    return 0;
  };
  const missileStat = (key, ident) => {
    const desc = Data.skillDesc[skill.skilldesc];
    const missile = Data.missileByName[desc?.[key]?.toLowerCase()] || Data.skills[0];
    if (!missile) return 0;
    return missileFormula(missile, ident, stats, level);
  };
  switch (ident) {
  case 'ln12': return linear(level, skill.param1 || 0, skill.param2 || 0);
  case 'dm12': return diminishing(level, skill.param1 || 0, skill.param2 || 0);
  case 'ln34': return linear(level, skill.param3 || 0, skill.param4 || 0);
  case 'dm34': return diminishing(level, skill.param3 || 0, skill.param4 || 0);
  case 'ln56': return linear(level, skill.param5 || 0, skill.param6 || 0);
  case 'dm56': return diminishing(level, skill.param5 || 0, skill.param6 || 0);
  case 'ln78': return linear(level, skill.param7 || 0, skill.param8 || 0);
  case 'dm78': return diminishing(level, skill.param7 || 0, skill.param8 || 0);
  case 'ln91': return linear(level, skill.param9 || 0, skill.param10 || 0);
  case 'dm91': return diminishing(level, skill.param9 || 0, skill.param10 || 0);
  case 'ln21': return linear(level, skill.param11 || 0, skill.param12 || 0);
  case 'dm21': return diminishing(level, skill.param11 || 0, skill.param12 || 0);
  case 'par1': return skill.param1 || 0;
  case 'par2': return skill.param2 || 0;
  case 'par3': return skill.param3 || 0;
  case 'par4': return skill.param4 || 0;
  case 'par5': return skill.param5 || 0;
  case 'par6': return skill.param6 || 0;
  case 'par7': return skill.param7 || 0;
  case 'par8': return skill.param8 || 0;
  case 'par9': return skill.param9 || 0;
  case 'pa10': return skill.param10 || 0;
  case 'pa11': return skill.param11 || 0;
  case 'pa12': return skill.param12 || 0;
  case 'lvl': return level;
  case 'edmn': return pctcalc2(levelScaling5(level, skill.emin || 0, skill.eminlev1 || 0, skill.eminlev2 || 0,
    skill.eminlev3 || 0, skill.eminlev4 || 0, skill.eminlev5 || 0) << (skill.hitshift || 0), skill.edmgsympercalc) >> 8;
  case 'edmx': return pctcalc(levelScaling5(level, skill.emax || 0, skill.emaxlev1 || 0, skill.emaxlev2 || 0,
    skill.emaxlev3 || 0, skill.emaxlev4 || 0, skill.emaxlev5 || 0) << (skill.hitshift || 0), skill.edmgsympercalc) >> 8;
  case 'edln': return d2_addpercent(levelScaling3(level, skill.elen || 0, skill.elevlen1 || 0, skill.elevlen2 || 0,
    skill.elevlen3 || 0), skillCalc(skill, skill.elensympercalc, stats, level));
  case 'toht': return skill.tohitcalc ? skillCalc(skill, skill.tohitcalc, stats, level) :
    linear(level, skill.tohit || 0, skill.levtohit || 0);
  case 'mana': return Math.max((skill.minmana || 0) << 8, (linear(level, skill.mana || 0, skill.lvlmana || 0) << (skill.manashift || 0))) >> 8;
  case 'mps': return ((Math.max((skill.minmana || 0) << 8, (linear(level, skill.mana || 0, skill.lvlmana || 0) << (skill.manashift || 0))) | 0) * 25) >> 9;
  case 'math': return passiveStat('passive_mastery_melee_th', 'passive_mastery_throw_th');
  case 'madm': return passiveStat('passive_mastery_melee_dmg', 'passive_mastery_throw_dmg');
  case 'macr': return passiveStat('passive_mastery_melee_crit', 'passive_mastery_throw_crit');
  case 'mapi': return passiveStat('skill_pierce');
  case 'manc': return passiveStat('passive_mastery_noconsume');
  case 'm1en': return missileStat('descmissile1', 'edmn');
  case 'm1ex': return missileStat('descmissile1', 'edmx');
  case 'm1el': return missileStat('descmissile1', 'edln');
  case 'm2en': return missileStat('descmissile2', 'edmn');
  case 'm2ex': return missileStat('descmissile2', 'edmx');
  case 'm2el': return missileStat('descmissile2', 'edln');
  case 'm3en': return missileStat('descmissile3', 'edmn');
  case 'm3ex': return missileStat('descmissile3', 'edmx');
  case 'm3el': return missileStat('descmissile3', 'edln');
  case 'm1rn': return missileStat('descmissile1', 'rang');
  case 'm2rn': return missileStat('descmissile2', 'rang');
  case 'm3rn': return missileStat('descmissile3', 'rang');
  case 'edns': return pctcalc2(levelScaling5(level, skill.emin || 0, skill.eminlev1 || 0, skill.eminlev2 || 0,
    skill.eminlev3 || 0, skill.eminlev4 || 0, skill.eminlev5 || 0) << (skill.hitshift || 0), skill.edmgsympercalc);
  case 'edxs': return pctcalc(levelScaling5(level, skill.emax || 0, skill.emaxlev1 || 0, skill.emaxlev2 || 0,
    skill.emaxlev3 || 0, skill.emaxlev4 || 0, skill.emaxlev5 || 0) << (skill.hitshift || 0), skill.edmgsympercalc);
  case 'ulvl': return stats.level || 0;
  case 'blvl': return stats.base_skills?.[skill.id] || 0;
  case 'usmc': return Math.max((skill.minmana || 0) << 8, (linear(level, skill.mana || 0, skill.lvlmana || 0) << (skill.manashift || 0))) | 0;
  case 'm1eo': return missileStat('descmissile1', 'edns');
  case 'm1ey': return missileStat('descmissile1', 'edxs');
  case 'm2eo': return missileStat('descmissile2', 'edns');
  case 'm2ey': return missileStat('descmissile2', 'edxs');
  case 'me3o': return missileStat('descmissile3', 'edns');
  case 'me3y': return missileStat('descmissile3', 'edxs');
  case 'enma': return mastery(pctcalc2(levelScaling5(level, skill.emin || 0, skill.eminlev1 || 0, skill.eminlev2 || 0,
    skill.eminlev3 || 0, skill.eminlev4 || 0, skill.eminlev5 || 0) << (skill.hitshift || 0), skill.edmgsympercalc)) >> 8;
  case 'exma': return mastery(pctcalc(levelScaling5(level, skill.emax || 0, skill.emaxlev1 || 0, skill.emaxlev2 || 0,
    skill.emaxlev3 || 0, skill.emaxlev4 || 0, skill.emaxlev5 || 0) << (skill.hitshift || 0), skill.edmgsympercalc)) >> 8;
  case 'edma': return d2_addpercent(levelScaling3(level, skill.elen || 0, skill.elevlen1 || 0, skill.elevlen2 || 0,
    skill.elevlen3 || 0), skillCalc(skill, skill.elensympercalc, stats, level));
  case 'enms': return mastery(pctcalc2(levelScaling5(level, skill.emin || 0, skill.eminlev1 || 0, skill.eminlev2 || 0,
    skill.eminlev3 || 0, skill.eminlev4 || 0, skill.eminlev5 || 0) << (skill.hitshift || 0), skill.edmgsympercalc));
  case 'exms': return mastery(pctcalc(levelScaling5(level, skill.emax || 0, skill.emaxlev1 || 0, skill.emaxlev2 || 0,
    skill.emaxlev3 || 0, skill.emaxlev4 || 0, skill.emaxlev5 || 0) << (skill.hitshift || 0), skill.edmgsympercalc));
  case 'len': return skillCalc(skill, skill.auralencalc, stats, level);
  case 'clc1': return skillCalc(skill, skill.calc1, stats, level);
  case 'clc2': return skillCalc(skill, skill.calc2, stats, level);
  case 'clc3': return skillCalc(skill, skill.calc3, stats, level);
  case 'clc4': return skillCalc(skill, skill.calc4, stats, level);
  case 'clc5': return skillCalc(skill, skill.calc5, stats, level);
  case 'clc6': return skillCalc(skill, skill.calc6, stats, level);
  case 'rng': return skillCalc(skill, skill.aurarangecalc, stats, level);
  case 'ast1': return skillCalc(skill, skill.aurastatcalc1, stats, level);
  case 'ast2': return skillCalc(skill, skill.aurastatcalc2, stats, level);
  case 'ast3': return skillCalc(skill, skill.aurastatcalc3, stats, level);
  case 'ast4': return skillCalc(skill, skill.aurastatcalc4, stats, level);
  case 'ast5': return skillCalc(skill, skill.aurastatcalc5, stats, level);
  case 'ast6': return skillCalc(skill, skill.aurastatcalc6, stats, level);
  case 'pst1': return skillCalc(skill, skill.passivecalc1, stats, level);
  case 'pst2': return skillCalc(skill, skill.passivecalc2, stats, level);
  case 'pst3': return skillCalc(skill, skill.passivecalc3, stats, level);
  case 'pst4': return skillCalc(skill, skill.passivecalc4, stats, level);
  case 'pst5': return skillCalc(skill, skill.passivecalc5, stats, level);
  case 'pst6': return skillCalc(skill, skill.passivecalc6, stats, level);
  case 'pets': return skillCalc(skill, skill.petmax, stats, level);
  case 'skpt': return skillCalc(skill, skill.skpoints, stats, level);

  case 'pnma':
  case 'pdmn': return pctcalc(levelScaling5(level, skill.mindam || 0, skill.minlevdam1 || 0, skill.minlevdam2 || 0,
    skill.minlevdam3 || 0, skill.minlevdam4 || 0, skill.minlevdam5 || 0) << (skill.hitshift || 0), skill.dmgsympercalc) >> 8;
  case 'pxma':
  case 'pdmx': return pctcalc(levelScaling5(level, skill.maxdam || 0, skill.maxlevdam1 || 0, skill.maxlevdam2 || 0,
    skill.maxlevdam3 || 0, skill.maxlevdam4 || 0, skill.maxlevdam5 || 0) << (skill.hitshift || 0), skill.dmgsympercalc) >> 8;
  case 'pnms':
  case 'pdns': return pctcalc(levelScaling5(level, skill.mindam || 0, skill.minlevdam1 || 0, skill.minlevdam2 || 0,
    skill.minlevdam3 || 0, skill.minlevdam4 || 0, skill.minlevdam5 || 0) << (skill.hitshift || 0), skill.dmgsympercalc);
  case 'pxms':
  case 'pdxs': return pctcalc(levelScaling5(level, skill.maxdam || 0, skill.maxlevdam1 || 0, skill.maxlevdam2 || 0,
    skill.maxlevdam3 || 0, skill.maxlevdam4 || 0, skill.maxlevdam5 || 0) << (skill.hitshift || 0), skill.dmgsympercalc);

  case 'mael': return stats.base?.[`passive_${skill.etype}_mastery`] || 0;

  case 'm1nm': return mastery(missileStat('descmissile1', 'edns'));
  case 'm1xm': return mastery(missileStat('descmissile1', 'edxs'));
  case 'm1sz': return missileStat('descmissile1', 'size');
  case 'mxrn':
    {
      const missile = Data.missileByName[skill.srvmissileb?.toLowerCase()];
      if (!missile) return 0;
      return missileFormula(missile, 'rang', stats, level);
    }
  default: return 0;
  }
}

function genericCalc(formula, stats, identCalc, level) {
  if (!formula) return 0;

  function evalNode(node) {
    switch (node?.type) {
    case 'Identifier': return identCalc(node.name);
    case 'Literal': return node.value | 0;
    case 'CallExpression':
      if (node.callee.type !== 'Identifier') throw Error('invalid expression');
      switch (node.callee.name) {
      case 'min': return Math.min(...node.arguments.map(evalNode));
      case 'max': return Math.max(...node.arguments.map(evalNode));
      case 'skill':
        {
          const skill = Data.skillByName[node.arguments[0].object.value.toLowerCase()] || Data.skills[0];
          if (!skill) return 0;
          return skillFormula(skill, node.arguments[0].property.name, stats, stats.skills[skill.id] || 0);
        }
      case 'stat': return stats.base?.[node.arguments[0].object.value] || 0;
      case 'sklvl':
        {
          const arg = node.arguments[0];
          const ident = arg.property.name;
          const level = identCalc(arg.object.property.name);
          const skill = Data.skillByName[arg.object.object.value.toLowerCase()] || Data.skills[0];
          if (!skill) return 0;
          return skillFormula(skill, ident, stats, level);
        }
      case 'miss':
        return missileFormula(Data.missileByName[node.arguments[0].object.value.toLowerCase()] || Data.missiles[0], node.arguments[0].property.name, stats, level);
      default: return evalNode(node.arguments[node.arguments.length - 1]);
      }
    case 'UnaryExpression': return unaryOps[node.operator](evalNode(node.argument));
    case 'BinaryExpression': return binaryOps[node.operator](evalNode(node.left), evalNode(node.right));
    case 'ConditionalExpression': return evalNode(node.test) ? evalNode(node.consequent) : evalNode(node.alternate);
    default: throw Error('invalid expression');
    }
  }

  try {
    return evalNode(jsep(formula));
  } catch (e) {
    // fix parentheses...
    if (e.description === 'Unclosed (') {
      return genericCalc(formula + ')', stats, identCalc, level);
    }
    return 0;
  }
}

export function skillCalc(skill, formula, stats, level) {
  if (!skill) return 0;
  return genericCalc(formula, stats, ident => skillFormula(skill, ident, stats, level), level);
}

export function missileCalc(missile, formula, stats, level) {
  if (!missile) return 0;
  return genericCalc(formula, stats, ident => missileFormula(missile, ident, stats, level), level);
}
